export const licenses: Record<string, string> = {
  'lic.title': 'License extension',
  // The first sentence of what was 'lic.subtitle' is now the header caption (pageSub.licenses).
  'lic.note': 'Thay cho Google Sheet; ASO và Monet vẫn đọc sheet cũ cho tới khi được chuyển sang đây.',
  'lic.tab.list': 'Danh sách',
  'lic.tab.usage': 'Nhật ký sử dụng',

  'lic.email': 'Email',
  'lic.status': 'Trạng thái',
  'lic.expiry': 'Hạn dùng',
  'lic.tools': 'Tool',
  'lic.role': 'Vai trò',
  'lic.notes': 'Ghi chú',
  'lic.lastSeen': 'Lần cuối',
  'lic.extVersion': 'Phiên bản ext',
  'lic.actions': 'Thao tác',

  'lic.status.active': 'đang dùng',
  'lic.status.revoked': 'đã thu hồi',
  'lic.role.reader': 'chỉ đọc',
  'lic.role.writer': 'được ghi',

  'lic.lifetime': 'vĩnh viễn',
  'lic.allTools': 'mọi tool',
  'lic.never': 'chưa bao giờ',

  'lic.add': 'Cấp license',
  'lic.edit': 'Sửa',
  'lic.revoke': 'Thu hồi',
  'lic.delete': 'Xoá',
  'lic.save': 'Lưu',
  'lic.cancel': 'Huỷ',

  'lic.form.newTitle': 'Cấp license mới',
  'lic.form.editTitle': 'Sửa license',
  'lic.form.emailHint': 'Lưu chữ thường. Mỗi người một dòng.',
  'lic.form.toolsHint':
    'Danh sách tool cách nhau bởi dấu phẩy, ví dụ owner-lens,aso. Để trống là được dùng mọi tool.',
  'lic.form.expiryHint': 'Để trống là không hết hạn. Đúng ngày ghi ở đây vẫn còn dùng được.',
  'lic.form.roleHint':
    'Vai trò ghi chỉ đổi giao diện của extension — quyền ghi thật vẫn do server kiểm lại.',
  'lic.form.emailRequired': 'Chưa nhập email',

  'lic.confirmRevoke': 'Thu hồi quyền của {email}?',
  'lic.confirmDelete': 'Xoá hẳn dòng của {email}? Thu hồi thì vẫn giữ lịch sử.',
  'lic.empty': 'Chưa có license nào.',
  'lic.saved': 'Đã lưu.',

  'lic.usage.filterEmail': 'Email',
  'lic.usage.filterTool': 'Tool',
  'lic.usage.from': 'Từ ngày',
  'lic.usage.to': 'Đến ngày',
  'lic.usage.apply': 'Lọc',
  'lic.usage.clear': 'Xoá lọc',
  'lic.usage.at': 'Thời điểm',
  'lic.usage.action': 'Hành động',
  'lic.usage.detail': 'Chi tiết',
  'lic.usage.empty': 'Không có dòng nào khớp bộ lọc.',
  'lic.usage.hint': 'Mới nhất trước, tối đa 200 dòng nếu không lọc hẹp lại.',
};
